import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#Code_svg__a)">
      <path
        fillRule="evenodd"
        d="M8.318 5.804a.71.71 0 0 1 .079 1.011l-2.5 2.879 2.5 2.878a.71.71 0 0 1-.08 1.01.733.733 0 0 1-1.023-.077l-2.798-3.22a.9.9 0 0 1 0-1.182l2.798-3.22a.733.733 0 0 1 1.024-.079m3.61 0a.733.733 0 0 1 1.025.078l2.798 3.22a.9.9 0 0 1 0 1.183l-2.798 3.22a.733.733 0 0 1-1.024.078.71.71 0 0 1-.079-1.01l2.5-2.88-2.5-2.878a.71.71 0 0 1 .079-1.01Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Code_svg__a">
        <path d="M2 2h15.668v15.668H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCode;
